import { createFileRoute } from "@tanstack/react-router";

import { StatsDebugPreview } from "~/features/player/components/StatsDebugView/StatsDebugPreview.tsx";
import { parseStatsDebugSearch } from "~/features/player/components/StatsDebugView/statsDebugSearch.ts";
import { resolveStatsDebugSelection } from "~/features/player/components/StatsDebugView/statsDebugUtils.ts";

const StatsDebugPreviewPage = () => <StatsDebugPreview {...resolveStatsDebugSelection(Route.useSearch())} />;

export const Route = createFileRoute("/_auth/dev/stats/preview")({
    validateSearch: parseStatsDebugSearch,
    component: StatsDebugPreviewPage,
});
